import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("按选择加入")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("按搜索加入")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("按选择删除")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("按搜索删除")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("导入批次")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("选择文件")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("确定")

import { ref, Ref, reactive, onBeforeMount, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { genFileId } from 'element-plus'
import { formatNumber, formatTime } from '@/utils/index'
import Api from '@/http/modules/index'
import dayjs from "dayjs"
import { row, to } from 'mathjs'

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

let {
// 成本公司
'GET/rt/company/list':companyListApi,
// 采购付款页面
'POST/procures/payment':procuresPaymentApi,
// 导出-采购付款
'POST/procures/export':exportApi,
// 采购批次列表(不分页)
'GET/procures':procuresListApi,
// 批量多选加入采购批次
'POST/procures/choose_add':procuresAddApi,
// 批量选择删除加入批次
'DELETE/procures/choose_deleted':procuresDeleteApi,
// 根据条件加入采购批次
'POST/procures/condition_add':conditionAddApi,
// 根据条件删除采购批次
'DELETE/procures/condition_deleted':conditionDelApi,
// 发票主体全部公司列表
'GET/companies/en_name/list': companiesFullEn_nameApi,
// 
'POST/procures/upload_add':procuresUploadAddApi
} = Api
const queryInfo=ref<any>({
  monthRange:[dayjs().startOf('month').format('YYYY-MM-DD'),dayjs().endOf('month').format('YYYY-MM-DD')]
})
const invoiceCompanyList=ref<any>([])
const companyList=ref<any>([])
const tableHeight=window.innerHeight-280
const pageInfo=reactive({
    page:1,
    size:30,
    total:0
})
const procuresPaymentList=ref([])

const tableLoad=ref(false)
const procuresList=ref<any>([])
const exportParams=ref({})
const selectedProcuresList=ref([])
const procuresPaymentLoading=ref(false)
const searchHandle=(isReset = false)=>{
    if(isReset){
        pageInfo.page=1
        queryInfo.value={monthRange:[dayjs().startOf('month').format('YYYY-MM-DD'),dayjs().endOf('month').format('YYYY-MM-DD')]}
    }
    let {page,size}=pageInfo
    let {invoiceCompany,company,domestic,type,monthRange,dateRange,companyId,existProcure,procureId,costId,initInvoiceCompany}=queryInfo.value
    let params:any={
        invoiceCompany,company,domestic,page,size,companyId,existProcure,procureId,costId,initInvoiceCompany,
        deliverTimeRange:{
            // from:monthRange&&monthRange.length?dayjs(monthRange[0]).startOf('month').format('YYYY-MM-DD'):'',
            // to:monthRange&&monthRange.length?dayjs(monthRange[1]).endOf('month').format('YYYY-MM-DD'):''
            from: monthRange?.[0],
            to: monthRange?.[1],

        },
        procureDateRange:{
            // from:dateRange&&dateRange.length?dayjs(dateRange[0]).format('YYYY-MM-DD'):'',
            // to:dateRange&&dateRange.length?dayjs(dateRange[1]).format('YYYY-MM-DD'):''
            from: dateRange?.[0],
            to: dateRange?.[1],
        }
    }
    if(type){
        params[type]=true
    }
    procuresPaymentLoading.value=true
    let copyParams=JSON.parse(JSON.stringify(params))
    delete copyParams.page
    delete copyParams.size
    exportParams.value=copyParams
    tableLoad.value=true
    procuresPaymentApi(params).then((res:any)=>{
        procuresPaymentList.value=res.data
        pageInfo.total=res.rowCount
    }).finally(()=>{
        tableLoad.value=false
        procuresPaymentLoading.value=false
    })
}
const procuresVisiable=ref(false)
const addProcuresLoading=ref(false)
const isDel=ref(false)
const procureId=ref("")
const addType=ref(1) //1：按选择加入，2：按搜索条件加入
const addHandle=(type:number)=>{
    if(type==1&&!selectedProcuresList.value.length){
        ElMessage.warning("请先勾选数据")
        return
    }
    if(type==2&&(!queryInfo.value.monthRange||!queryInfo.value.monthRange.length)){
        ElMessage.warning("请根据账务成本月份筛选的结果来加入采购批次")
        return
    }
    isDel.value=false
    addType.value=type
    procureId.value=''
    procuresVisiable.value=true
}
const addProcures=()=>{
    let params:any=null
    if(addType.value==1){
        params={
            procureId:procureId.value,
            costIds:selectedProcuresList.value.map((el:any)=>el.costId)
        }
    }else{
        let {invoiceCompany,company,domestic,monthRange}=queryInfo.value
        params={
            procureId:procureId.value,
            invoiceCompany,//发票主体
            domestic,//境内外(0:境外 1:境内)
            company,//成本公司  /api/rt/company/list GET
            deliverTimeRange:{
                from:monthRange&&monthRange.length?dayjs(monthRange[0]).startOf('month').format('YYYY-MM-DD'):'',
                to:monthRange&&monthRange.length?dayjs(monthRange[1]).startOf('month').format('YYYY-MM-DD'):''
            }//账务成本月份(月份选择框)
        }
    }
    addProcuresLoading.value=true
    let handleApi=addType.value==1?procuresAddApi:conditionAddApi
    handleApi(params).then(()=>{
        ElMessage.success('添加成功')
        procuresVisiable.value=false
        searchHandle()
    }).finally(()=>{
        addProcuresLoading.value=false
    })
}
const deleteHandle=()=>{
    if(!selectedProcuresList.value.length){
        ElMessage.warning("请先勾选数据")
        return
    }
    ElMessageBox.confirm('确定删除勾选数据？',{confirmButtonText:'确定',cancelButtonText:"取消"}).then(()=>{
        let params={
            costIds:selectedProcuresList.value.map((el:any)=>el.costId)
        }
        procuresDeleteApi(params).then(()=>{
            ElMessage.success('删除成功')
            selectedProcuresList.value=[]
            searchHandle()
        })
    })
}
const procuresHandle=()=>{
    isDel.value=true
    procuresVisiable.value=true
}
const conditionDelHandle=()=>{
    let {invoiceCompany,company,domestic,monthRange}=queryInfo.value
    // if(!monthRange||!monthRange.length){
    //     ElMessage.warning("请根据账务成本月份筛选的结果来加入采购批次")
    //     return
    // }
    if(!procureId.value){
    ElMessage.warning("请选择批次")
    return
}
    let params={
        procureId:procureId.value,
        invoiceCompany,//发票主体
        domestic,//境内外(0:境外 1:境内)
        company,//成本公司  /api/rt/company/list GET
        deliverTimeRange:{
            from:monthRange&&monthRange.length?dayjs(monthRange[0]).startOf('month').format('YYYY-MM-DD'):'',
            to:monthRange&&monthRange.length?dayjs(monthRange[1]).startOf('month').format('YYYY-MM-DD'):''
        }//账务成本月份(月份选择框)
    }
    ElMessageBox.confirm('确定删除采购批次？',{confirmButtonText:'确定',cancelButtonText:"取消"}).then(()=>{
        addProcuresLoading.value=true
        conditionDelApi(params).then(()=>{
            ElMessage.success('删除成功')
            searchHandle()
            procuresVisiable.value=false
        }).finally(()=>{
            addProcuresLoading.value=false
        })
    })
    
}
const upload=ref()
const procuresImportVisiable=ref(false)
const procuresImportLoading=ref(false)
const importFile=ref()
const importProcureId=ref("")
const fileChange = (file: any, files: any) => {
    importFile.value = file.raw
}
const handleExceed=(files:any)=>{
    upload.value!.clearFiles()
    const file = files[0]
    file.uid = genFileId()
    upload.value!.handleStart(file)
}
const importHandle=()=>{
    if(!importProcureId.value||!importFile.value){
        let message=!importProcureId.value?'请选择批次':'请选择上传文件'
        ElMessage.warning(message)
        return
    }
    let params={
        file:importFile.value,
        procureId:importProcureId.value
    }
    procuresImportLoading.value=true
    procuresUploadAddApi(params,{contentType: 'formData'}).then(()=>{
        ElMessage.success("导入成功")
        procuresImportVisiable.value=false
    }).finally(()=>{
        procuresImportLoading.value=false
    })
}
const resetProcuresImport=()=>{
    upload.value!.clearFiles()
    importProcureId.value=""
    importFile.value=null
}
const getProcuresList=()=>{
    procuresListApi().then((res:any)=>{
        procuresList.value=res
    })
}
onMounted(()=>{
    companyListApi().then((res:any)=>{
        companyList.value=res.company
    })
    getProcuresList()
    companiesFullEn_nameApi().then((rep: any) => {
        invoiceCompanyList.value = rep.enName

  })
    searchHandle()
})

expose({
  searchHandle,
  queryInfo,
  pageInfo,
  getProcuresList
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "搜素" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              inline: "",
              "label-width": "120",
              class: "searchBg",
              disabled: tableLoad.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "发票主体:" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      filterable: "",
                      style: {"width":"240px"},
                      modelValue: queryInfo.value.invoiceCompany,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryInfo.value.invoiceCompany) = $event)),
                      clearable: "",
                      placeholder: "请选择发票主体"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invoiceCompanyList.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            value: item,
                            label: item
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "固定发票主体:" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      filterable: "",
                      style: {"width":"240px"},
                      modelValue: queryInfo.value.initInvoiceCompany,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryInfo.value.initInvoiceCompany) = $event)),
                      clearable: "",
                      placeholder: "请选择固定发票主体"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invoiceCompanyList.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            value: item,
                            label: item
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "成本公司:" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      filterable: "",
                      style: {"width":"240px"},
                      modelValue: queryInfo.value.company,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryInfo.value.company) = $event)),
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyList.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            value: item,
                            label: item
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "成本ID:" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      style: {"width":"240px"},
                      placeholder: "成本ID",
                      modelValue: queryInfo.value.costId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queryInfo.value.costId) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "境内外:" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      style: {"width":"240px"},
                      modelValue: queryInfo.value.domestic,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((queryInfo.value.domestic) = $event)),
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "境内",
                          value: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "境外",
                          value: 0
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "变化选项:" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      style: {"width":"240px"},
                      modelValue: queryInfo.value.type,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((queryInfo.value.type) = $event)),
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "发票主体有变化",
                          value: "checkInvoiceCompany"
                        }),
                        _createVNode(_component_el_option, {
                          label: "成本公司有变化",
                          value: "checkCostCompany"
                        }),
                        _createVNode(_component_el_option, {
                          label: "订单国内外有变化",
                          value: "checkDomestic"
                        }),
                        _createVNode(_component_el_option, {
                          label: "任意变化",
                          value: "checkAll"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "公司:" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      style: {"width":"240px"},
                      modelValue: queryInfo.value.companyId,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((queryInfo.value.companyId) = $event)),
                      placeholder: "请选择公司",
                      filterable: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysCompany, (group) => {
                          return (_openBlock(), _createBlock(_component_el_option_group, {
                            label: group.label,
                            key: group.label
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (comp) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: comp.alias,
                                  value: comp.id,
                                  key: comp.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "采购批次:" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      filterable: "",
                      clearable: "",
                      style: {"width":"240px"},
                      modelValue: queryInfo.value.procureId,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((queryInfo.value.procureId) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(procuresList.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "是否被选中:" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      clearable: "",
                      style: {"width":"240px"},
                      modelValue: queryInfo.value.existProcure,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((queryInfo.value.existProcure) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "是",
                          value: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "否",
                          value: 0
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "账务成本月份:" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      clearable: "",
                      modelValue: queryInfo.value.monthRange,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((queryInfo.value.monthRange) = $event)),
                      type: "monthrange",
                      "range-separator": "到",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      "value-format": "YYYY-MM-DD"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "采购日期:" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      clearable: "",
                      modelValue: queryInfo.value.dateRange,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((queryInfo.value.dateRange) = $event)),
                      type: "daterange",
                      "range-separator": "到",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      "value-format": "YYYY-MM-DD"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (searchHandle()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (searchHandle(true)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_3,
    _createVNode(_component_el_button, {
      onClick: _cache[13] || (_cache[13] = ($event: any) => (addHandle(1)))
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      onClick: _cache[14] || (_cache[14] = ($event: any) => (addHandle(2)))
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      onClick: deleteHandle,
      type: "danger"
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      onClick: procuresHandle,
      type: "danger"
    }, {
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    }),
    _createVNode(_component_eptBtn, {
      type: "primary",
      exportFn: _unref(exportApi),
      exportText: '导出',
      exportParam: exportParams.value
    }, null, 8, ["exportFn", "exportParam"]),
    _createVNode(_component_el_button, {
      onClick: _cache[15] || (_cache[15] = ($event: any) => (procuresImportVisiable.value=true))
    }, {
      default: _withCtx(() => [
        _hoisted_8
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: procuresPaymentList.value,
      "max-height": tableHeight+'px',
      "row-key": "costId",
      onSelectionChange: _cache[16] || (_cache[16] = (val)=>selectedProcuresList.value=val),
      class: "mt-10 mb-10",
      style: {"width":"100%"},
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          width: "55",
          type: "selection",
          "reserve-selection": "",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "订单编号",
          width: "120",
          prop: "no",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "发票主体",
          width: "180",
          prop: "invoiceCompany",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "订单交付日期",
          width: "165",
          prop: "deliverTime"
        }),
        _createVNode(_component_el_table_column, {
          label: "账务月份",
          width: "120",
          prop: "accountMonth"
        }),
        _createVNode(_component_el_table_column, {
          label: "ID",
          width: "100",
          prop: "costId"
        }),
        _createVNode(_component_el_table_column, {
          label: "译员id",
          width: "100",
          prop: "resourceId"
        }),
        _createVNode(_component_el_table_column, {
          label: "是否计算",
          width: "100",
          prop: "isNoCalculated",
          formatter: (row)=>row.isNoCalculated?'否':'是'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "译员币种",
          width: "100",
          prop: "resourceCurrency"
        }),
        _createVNode(_component_el_table_column, {
          label: "贷方",
          width: "100",
          prop: "credit"
        }),
        _createVNode(_component_el_table_column, {
          label: "余额时间",
          width: "165",
          prop: "paymentTime"
        }),
        _createVNode(_component_el_table_column, {
          label: "创建时间",
          width: "165",
          prop: "dateCreated"
        }),
        _createVNode(_component_el_table_column, {
          label: "成本公司",
          prop: "company",
          width: "100",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "订单境内外",
          width: "100",
          prop: "domestic",
          formatter: (row)=>row.domestic?'境内':'境外'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "采购日期",
          width: "165",
          prop: "procureDate"
        }),
        _createVNode(_component_el_table_column, {
          label: "固定成本公司",
          "show-overflow-tooltip": "",
          width: "120",
          prop: "costInitCompany"
        }),
        _createVNode(_component_el_table_column, {
          label: "固定发票主体",
          "show-overflow-tooltip": "",
          width: "120",
          prop: "orderInitCompany"
        }),
        _createVNode(_component_el_table_column, {
          label: "固定境内外",
          width: "100",
          prop: "orderInitDomestic",
          formatter: (row)=>row.orderInitDomestic?'境内':'境外'
        }, null, 8, ["formatter"])
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, procuresPaymentLoading.value]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      disabled: tableLoad.value,
      "current-page": _unref(pageInfo).page,
      "onUpdate:current-page": _cache[17] || (_cache[17] = ($event: any) => ((_unref(pageInfo).page) = $event)),
      "page-size": _unref(pageInfo).size,
      "onUpdate:page-size": _cache[18] || (_cache[18] = ($event: any) => ((_unref(pageInfo).size) = $event)),
      "page-sizes": [30, 120, 300, 400,500],
      layout: "sizes, prev, pager, next, total, jumper",
      total: _unref(pageInfo).total,
      onSizeChange: _cache[19] || (_cache[19] = ()=>searchHandle()),
      onCurrentChange: _cache[20] || (_cache[20] = ()=>searchHandle())
    }, null, 8, ["disabled", "current-page", "page-size", "total"]),
    _createVNode(_component_el_dialog, {
      width: "500",
      title: isDel.value?'批量删除采购批次':'批量加入采购批次',
      modelValue: procuresVisiable.value,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((procuresVisiable).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[22] || (_cache[22] = ($event: any) => (procuresVisiable.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        (isDel.value)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              loading: addProcuresLoading.value,
              onClick: conditionDelHandle,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["loading"]))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              loading: addProcuresLoading.value,
              onClick: addProcures,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }, 8, ["loading"]))
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_select, {
          modelValue: procureId.value,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((procureId).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(procuresList.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_dialog, {
      width: "700",
      title: "导入批次",
      onClose: resetProcuresImport,
      modelValue: procuresImportVisiable.value,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((procuresImportVisiable).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          loading: procuresImportLoading.value,
          onClick: _cache[25] || (_cache[25] = ($event: any) => (procuresImportVisiable.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, {
          loading: procuresImportLoading.value,
          onClick: importHandle,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "80" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "批次" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: importProcureId.value,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((importProcureId).value = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(procuresList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "文件" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  ref_key: "upload",
                  ref: upload,
                  limit: 1,
                  "on-exceed": handleExceed,
                  "auto-upload": false,
                  "on-change": fileChange,
                  loading: procuresImportLoading.value
                }, {
                  trigger: _withCtx(() => [
                    _createVNode(_component_el_button, { type: "primary" }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})